import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { MessagesModule } from 'app/fuse-template/layout/common/messages/messages.module';
import { NotificationsModule } from 'app/fuse-template/layout/common/notifications/notifications.module';
import { SearchModule } from 'app/fuse-template/layout/common/search/search.module';
import { ShortcutsModule } from 'app/fuse-template/layout/common/shortcuts/shortcuts.module';
import { UserModule } from 'app/fuse-template/layout/common/user/user.module';
import { CenteredLayoutComponent } from 'app/fuse-template/layout/layouts/horizontal/centered/centered.component';
import { SharedModule } from 'app/fuse-template/shared/shared.module';

@NgModule({
    declarations: [CenteredLayoutComponent],
    exports: [CenteredLayoutComponent],
    imports: [
        RouterModule,
        FuseLoadingBarComponent,
        FuseFullscreenComponent,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MessagesModule,
        NotificationsModule,
        SearchModule,
        ShortcutsModule,
        UserModule,
        SharedModule,
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class CenteredLayoutModule {}
